module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-one"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" was nine when I saw my first ghost.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" My father and I were raking leaves in the cemetery where he’d worked for years as the caretaker. It was early autumn, not yet cool enough for a sweater, but on that particular afternoon there was a noticeable bite in the air as the sun dipped toward the horizon. A mild breeze carried the scent of wood smoke and pine needles, and as the wind picked up, a flock of black birds took flight from the treetops and glided like a storm cloud across the pale blue sky.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I put a hand to my eyes as I watched them. When my gaze finally dropped, I saw him in the distance. He stood beneath the drooping branches of a live oak, and the green-gold light that glimmered down through the Spanish moss cast a preternatural glow on the space around him. But he was in shadows, so much so that I wondered for a moment if he was only a mirage.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As the light faded, he became more defined, and I could even make out his features. He was old, even more ancient than my father, with white hair brushing the collar of his suit coat and eyes that seemed to burn with an inner flame.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" My father was bent to his work and as the rake moved steadily over the graves, he said under his breath, “Don’t look at him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I turned in surprise. “You see him, too?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes, I see him. Now get back to work.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “But who is he—”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I said don’t look at him!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" His sharp tone stunned me. I could count on one hand the number of times he’d ever raised his voice to me. That he had done so now, without provocation, made me instantly tear up. The one thing I could never abide was my father’s disapproval.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Amelia.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" There was regret in his tone and what I would later come to understand as pity in his blue eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’m sorry I spoke so harshly, but it’s important that you do as I say. You mustn’t look at him,” he said in a softer tone. “Any of them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Is he a—”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Something cold touched my spine and it was all I could do to keep my gaze trained on the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Papa,” I whispered. I had always called him this. I don’t know why I’d latched on to such an old-fashioned moniker, but it suited him. He had always seemed very old to me, even though he was not yet fifty. For as long as I could remember, his face had been heavily lined and weathered, like the cracked mud of a dry creek bed, and his shoulders drooped from years of bending over the graves.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But despite his poor posture, there was great dignity in his bearing and much kindness in his eyes and in his smile. I loved him with every fiber of my nine-year-old being. He and Mama were my whole world. Or had been, until that moment.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I saw something shift in Papa’s face and then his eyes slowly closed in resignation. He laid aside our rakes and placed his hand on my shoulder.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Let’s rest for a spell,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" We sat on the ground, our backs to the ghost, as we watched dusk creep in from the Lowcountry. I couldn’t stop shivering, even though the waning light was still warm on my face.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Who is he?” I finally whispered, unable to bear the quiet any longer.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I don’t know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Why can’t I look at him?” It occurred to me then that I was more afraid of what Papa was about to tell me than I was of the ghost.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You don’t want him to know that you can see him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Why not?” When he didn’t answer, I picked up a twig and poked it through a dead leaf, spinning it like a pinwheel between my fingers. “Why not, Papa?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Because what the dead want more than anything is to be a part of our world again. They’re like parasites, drawn to our energy, feeding off our warmth. If they know you can see them, they’ll cling to you like blight. You’ll never be rid of them. And your life will never again be your own.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I don’t know if I completely understood what he told me, but the notion of being haunted forever terrified me.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Not everyone can see them,” he said. “For those of us who can, there are certain precautions we must take in order to protect ourselves and those around us. The first and most important is this—never acknowledge the dead. Don’t look at them, don’t speak to them, don’t let them sense your fear. Even when they touch you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A chill shimmied over me. “They…touch you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Sometimes they do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “And you can feel it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He drew a breath. “Yes. You can feel it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I threw away the stick, and pulled up my knees, wrapping my arms tightly around them. Somehow, even at my young age, I was able to remain calm on the outside, but my insides had gone numb with dread.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “The second thing you must remember is this,” Papa said. “Never stray too far from hallowed ground.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “What’s hallowed ground?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “The old part of this cemetery is hallowed ground. There are other places, too, where you’ll be safe. Natural places. After a while, instinct will lead you to them. You’ll know where and when to seek them out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I tried to digest this puzzling detail, but I really didn’t understand the concept of hallowed ground, although I’d always known the old part of the cemetery was special.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Nestled against the side of a hill and protected by the outstretched arms of the live oaks, Rosehill was shady and beautiful, the most serene place I could imagine. It had been closed to the public for years, and sometimes as I wandered alone—and often lonely—through the lush fern beds and long curtains of silvery moss, I pretended the crumbling angels were wood nymphs and fairies and I their ruler, queen of my very own graveyard kingdom.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" My father’s voice brought me back to the real world. “Rule Number Three,” he said. “Keep your distance from those who are haunted. If they seek you out, turn away from them, for they constitute a terrible threat and cannot be trusted.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Are there any more rules?” I asked, because I didn’t know what else I was supposed to say.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes, but we’ll talk about the rest later. It’s getting late. We should probably head home before your mother starts to worry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Can she see them?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No. And you mustn’t tell her that you can.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Why not?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “She doesn’t believe in ghosts. She’d think you’re imagining things. Or telling stories.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I would never lie to Mama!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I know that. But this has to be our secret. When you’re older, you’ll understand. For now, just do your best to follow the rules and everything will be fine. Can you do that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes, Papa.” But even as I promised, it was all I could do to keep from glancing over my shoulder.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The breeze picked up and the chill inside me deepened. Somehow, I managed to keep from turning, but I knew the ghost had drifted closer. Papa knew it, too. I could feel the tension in him as he murmured, “No more talking. Just remember what I told you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I will, Papa.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The ghost’s frigid breath feathered down the back of my neck and I started to tremble. I couldn’t help myself.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Cold?” my father asked in his normal voice. “Well, it’s getting to be that time of year. Summer can’t last forever.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I didn’t say anything. I couldn’t. The ghost’s hands were in my hair. He lifted the golden strands, still warm from the sun, and let them sift through his fingers.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Papa got to his feet and pulled me up with him. The ghost skittered away for a moment, then floated back.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “We best be getting on home. Your mother’s cooking up a mess of shrimp tonight.” He picked up the rakes and hoisted them to his shoulder.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “And grits?” I asked, though my voice was hardly louder than a whisper.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I expect so. Come on. Let’s cut through the old cemetery. I want to show you the work I’ve done on some of the gravestones. I know how much you love the angels.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He took my hand and squeezed my fingers in reassurance as we set out across the cemetery, the ghost at our heels.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" By the time we reached the old section, Papa had already pulled the key from his pocket. He turned the lock and the heavy iron gate swung silently inward on well-oiled hinges.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" We stepped through into that dusky sanctuary and suddenly I wasn’t afraid anymore. My newfound courage emboldened me. I pretended to trip and when I bent to tie my shoelaces, I glanced back at the gate. The ghost hovered just outside. It was obvious he was unable to enter, and I couldn’t help but give a childish smirk.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" When I straightened, Papa glared down at me. “Rule Number Four,” he said sternly. “Never, ever tempt fate.”")])]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', [_vm._v(" The childhood memory flitted away as the waitress approached with my first course—roasted green-tomato soup, which I’d been told was a house specialty—along with the pecan pie I planned to have for dessert. Six months ago, I’d moved from Columbia to Charleston, making it my home base, but I’d never had dinner at any of the upscale waterfront restaurants. My budget normally didn’t allow for fine dining, but tonight was special.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As the waitress topped off my champagne, I caught her curious, sidelong glance, but I didn’t let it bother me. Just because I happened to be alone was no reason to deprive myself of a celebration.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Earlier, I’d taken a leisurely stroll along the Battery, pausing at the very tip of the peninsula to enjoy the sunset. Behind me, the whole city was bathed in crimson; before me, a fractured sky shifted into kaleidoscopic patterns of rose, lavender and gold. A Carolina sunset never failed to move me, but with the approaching twilight everything had turned gray. Mist drifted in from the sea and settled over the treetops like a silver canopy. As I watched the gauzy swirl from a table by the window, my elation faded.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dusk is a dangerous time for people like me. An in-between time just as the seashore and the edge of a forest are in-between places. The Celts had a name for these landscapes—")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("caol’ ait.")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Thin places where the barrier between our world and the next is but a gossamer veil.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Turning from the window, I sipped champagne, determined not to let the encroaching spirit world spoil my celebration. After all, it wasn’t every day an unexpected windfall came my way, and for barely lifting a finger.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" My work usually consists of many hours of manual labor for modest pay. I’m a cemetery restorer. I travel all over the South, cleaning up forgotten and abandoned graveyards and repairing worn and broken headstones. It’s painstaking, sometimes back-breaking work, and a huge cemetery can take years to restore fully, so there is no such thing as instant gratification in my profession. But I love what I do. We Southerners worship our ancestors, and I’m gratified that my efforts in some small way enable people of the present to more fully appreciate those who came before us.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" In my spare time, I run a blog called ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Digging Graves,")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" where taphophiles—lovers of cemeteries—and other like-minded folks can exchange photographs, restoration techniques and, yes, even the occasional ghost story. I’d started the blog as a hobby, but over the past few months, my readership had exploded.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It all started with the restoration of an old cemetery in the small, northeast Georgia town of Samara. The freshest grave there was over a hundred years old and some of the earliest dated back to pre–Civil War days.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The cemetery had been badly neglected since the local historical society ran out of money in the sixties. The sunken graves were overgrown, the headstones worn nearly smooth by erosion. Vandals had been busy there, too, and the first order of business was to pick up and cart away nearly four decades of trash.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Rumors of a haunting had persisted for years and some of the townspeople refused to set foot through the gates. It was hard to find and keep good help, even though I knew for a fact there were no ghosts in Samara Cemetery.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I ended up doing most of the work myself, but once the cleanup was completed, the attitude of the locals transformed dramatically. They said it was as if a dark cloud had been lifted from their town, and some went so far as to claim that the restoration had been both physical and spiritual.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A reporter and film crew from a station in Athens were sent out to interview me and when the clip turned up online, someone noticed a reflection in the background that had a vague, humanlike form. It appeared to be floating over the cemetery, ascending heavenward.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" There was nothing supernatural about the anomaly, merely a trick of the light, but dozens of paranormal websites ran with it and the YouTube video went viral. That’s when people from all over the world started flocking to ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Digging Graves,")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" where I was known as the Graveyard Queen. The traffic became so heavy that the producers of a ghost hunter television program made an offer to advertise on my site.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Which is how I came to be sipping champagne and savoring a wild mushroom tart at the glamorous Pavilion on the Bay restaurant.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Life was treating me well these days, I thought a little smugly, and then I saw the ghost.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Even worse, he saw me.")])])])]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57739022","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter_One.vue
// module id = 78
// module chunks = 0